define('views/modules/calendar/personal-data/manager/edit/personal-data-edit-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'models/calendar/personal-data/personal-data-type',
    // Views
    'views/parts/panel/base-panel',
    'views/modules/calendar/personal-data/manager/edit/personal-data-edit-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // models
    MPersonalDataType,
    // views
    VBasePanel,
    VPersonalDataEditContent
) {

    var VPersonalDataEditPanel = VBasePanel.extend({
        header: {
            title: "calendar:Personal data",
            subtitle: "calendar:Adding/Modify a personal data type",
        },

        tabs: [{ id: 'edit', title: 'Edit', icon: 'sl-icon-edit', active: true }],
        content: {
            edit: VPersonalDataEditContent,
        },
        defaultView: 'edit',

        initialize: function(opt) {
            this.group = opt.group;
            this.model = new MPersonalDataType({ group: this.group });
            var edit = this.getView('edit', { model: this.model });
            this.listenTo(edit, 'form:success', this.onSuccess);
        },

        onSuccess: function(model) {
            this.trigger('form:success', model);
            this.close();
        },

        setModel: function(model) {
            if (!model) return;
            var attrs = model.attributes || model;
            this.model.reset(attrs);
            this.model.fetch();
            this.model.set("group", this.group);
            return this;
        },

        resetModel: function(attrs, options) {
            this.model.reset(attrs, options);
            this.model.set("group", this.group);
            return this;
        },

    });

    return VPersonalDataEditPanel;
});

